import React, { useEffect, useState } from "react";
import axios from "axios";
import { variables } from "./Variables.js";

export default function CricketMatches() {
  const jsonUrl = variables.basename_url + "updates/index/Athlethixnet_HomeEn_Matches.json";

  const [isLoading, setIsLoading] = useState(true);
  const todayStr = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState("");
  const [hasSelectedDate, setHasSelectedDate] = useState(false);
  const [leagueData, setLeagueData] = useState({});

  /* ===== Date Helpers (Same Cricket) ===== */
  const getSelectedMonthYear = () => {
    if (!selectedDate) return "All Matches";
    const date = new Date(selectedDate);
    return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  };

  const changeDate = (offset) => {
    const current = selectedDate ? new Date(selectedDate) : new Date();
    current.setDate(current.getDate() + offset);
    setSelectedDate(current.toISOString().split("T")[0]);
    setHasSelectedDate(true);
  };

  const generateDateList = () => {
    const dates = [];
    for (let i = -3; i <= 3; i++) {
      const d = selectedDate ? new Date(selectedDate) : new Date();
      d.setDate(d.getDate() + i);
      dates.push({
        fullDate: d.toISOString().split("T")[0],
        dayName: d.toLocaleDateString("en-US", { weekday: "short" }),
        dayNumber: d.getDate(),
      });
    }
    return dates;
  };

  const dateList = generateDateList();

  /* ===== Fetch Tennis Matches ===== */
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const res = await axios.get(jsonUrl);
        const data = res.data;

        // ✅ Cricket only
        const tennisMatches = data.filter(
          (match) => match.SGT_name === "Cricket"
        );

        // ✅ Date filter
        const dateFiltered = hasSelectedDate
          ? tennisMatches.filter(
            (m) => m.SM_game_date_time?.split("T")[0] === selectedDate
          )
          : tennisMatches;

        // ✅ Group by League
        const organized = dateFiltered.reduce((acc, match) => {
          const section = match.SLT_name_en;
          if (!acc[section]) acc[section] = [];
          acc[section].push(match);
          return acc;
        }, {});

        setLeagueData(organized);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedDate, hasSelectedDate, jsonUrl]);

  return (
    <div className="container custom-container">
      {/* ===== Intro ===== */}
      <div className="feature-news-content mt-3">
        <p className="TitleSectionFont p-1 bg-white">
          Welcome to AthletixNet Tennis Matches! Find all tennis match schedules,
          live scores, and highlights.
        </p>
      </div>

      {/* ===== Buttons ===== */}
      <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap">
        <div className="d-flex align-items-center">
          <a href="FootballMatches">
            <button type="button" className="grayBackground text-white p-2 rounded border border-white mr-2">Football</button>
          </a>
          <a href="TennisMatches">
            <button type="button" className=" grayBackground text-white p-2 rounded border border-white mr-2">Tennis</button>
          </a>
          <a href="BasketballMatches">
            <button type="button" className="grayBackground text-white p-2 rounded border border-white mr-2">Basketball</button>
          </a>
          <a href="CricketMatches">
            <button type="button" className="redbackcolor text-white p-2 rounded border border-white ">Cricket</button>
          </a>
        </div>

        <div>
          <h3 style={{ fontSize: "24px", margin: 0 }}>
            {getSelectedMonthYear()}
            <span style={{ fontSize: "12px", marginLeft: "8px", color: "#888" }}>
              Please select date :
            </span>
          </h3>
        </div>

        <input
          type="date"
          className="form-control form-control-sm"
          value={selectedDate}
          onChange={(e) => {
            setSelectedDate(e.target.value);
            setHasSelectedDate(true);
          }}
          style={{ width: "auto" }}
        />
      </div>

      {/* ===== Date Scroller ===== */}
      <div className="date-scroller-container mb-4 shadow-sm bg-white rounded">
        <div className="d-flex justify-content-between align-items-center p-2">
          <button className="btn btn-light" onClick={() => changeDate(-1)}>
            ‹
          </button>

          <div className="d-flex overflow-auto">
            {dateList.map((d, i) => {
              const active = selectedDate === d.fullDate;
              const today = todayStr === d.fullDate;

              return (
                <div
                  key={i}
                  onClick={() => {
                    setSelectedDate(d.fullDate);
                    setHasSelectedDate(true);
                  }}
                  className="text-center mx-2 p-2"
                  style={{
                    cursor: "pointer",
                    minWidth: "60px",
                    borderBottom: active ? "3px solid #dc3545" : "none",
                  }}
                >
                  <div style={{ fontSize: "12px", color: active ? "#dc3545" : "#888" }}>
                    {today ? "Today" : d.dayName}
                  </div>
                  <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {d.dayNumber}
                  </div>
                </div>
              );
            })}
          </div>

          <button className="btn btn-light" onClick={() => changeDate(1)}>
            ›
          </button>
        </div>
      </div>

      {/* ===== Matches ===== */}
      {isLoading ? (
        <p>Loading...</p>
      ) : Object.keys(leagueData).length === 0 ? (
        <div className="text-center p-4">
          <h5>No tennis are scheduled for the selected day. Please check another date.</h5>
        </div>
      ) : (
        Object.keys(leagueData).map((section, index) => (
          <div className="mb-3" key={section}>
            <p hidden>{index++}</p>
            <div
              className="col-xl-12 col-lg-12 col-md-12 col-sm-12 float-left HeaderTable-margin box-title mt-1"
              style={{ backgroundColor: index % 2 === 0 ? "white" : "#eceef2" }}
            >
              <p hidden>{index++}</p>
              <div className="d-flex">
                <div>
                  <img
                    className="Match-logo"
                    src={`${variables.MatchesImagePath}${leagueData[section][0].SLT_Logo}`}
                    width={35}
                    height={35}
                    alt={section}
                  />
                </div>
                <div className="logoSize ml-3">
                  <a href={"AllResultMatcehs?SLT_id=" + leagueData[section][0].SLT_id} target="_blank" className="text-decoration-none">{section}</a>
                </div>
              </div>
            </div>
            {leagueData[section].map((match, idx) => (
              <div
                key={idx}
                className="container col-xl-12 col-lg-12 col-md-11 col-sm-11 BodyTable-margin pt-2 d-flex"
                style={{ backgroundColor: index % 2 === 0 ? "white" : "#eceef2" }}
              >
                <p hidden>{index++}</p>
                <div className="col-md-3 border-0 rounded ml-3">
                  <h6 className="text-center BlueMacthColor">
                    {match.SM_game_date_time
                      ? match.SM_game_date_time.split('T')[0] + ' ' + match.SM_game_date_time.split('T')[1].slice(0, 5)
                      : ''}
                  </h6>
                </div>

                <div className="col-md-3 BlueMacthColor border-0 rounded text-right">
                  <h6 className="BlueMacthColor">
                    {match.Team1}
                    <img
                      className="ml-3"
                      src={`${variables.MatchesImg}${match.ST_logo}`}
                      width={32}
                      height={32}
                      alt={match.Team1}
                    />
                  </h6>
                </div>
                <div className="col-md-2 border-0 rounded">
                  <h6 className="text-center BlueMacthColor">
                    {match.SM_score1 === '' || match.SM_score1 === '-1' || match.SM_score1 === '-' ? ' ' : match.SM_score1}<span className="pl-1 pr-1">-</span>{match.SM_score2 === '' || match.SM_score2 === '-1' || match.SM_score1 === '-' ? ' ' : match.SM_score2}
                  </h6>
                </div>
                <div className="col-md-4 BlueMacthColor border-0 rounded text-left">
                  <h6 className="BlueMacthColor">
                    <img
                      className="mr-3"
                      src={`${variables.MatchesImg}${match.ST_logo1}`}
                      width={32}
                      height={32}
                      alt={match.Team2}
                    />
                    {match.Team2}
                  </h6>
                </div>
              </div>
            ))}
          </div>
        ))
      )}
    </div>
  );
}
